module.exports = __webpack_public_path__ + "static/sports-broadcast-students-prepare-for-prime-time-1a98dcb175f17adf172274a6aff464f9.jpg";